import env from './config'

export default env